<template>
  <div>
    <div class="row">
      <div class="col">
        <div class="row">
          <div class="col d-flex">
            <div class="col alert alert-primary group-title">
              <span class="my-auto" v-if="needPresenterData() || (author && author.role_id === 2)"><icon
                :icon="['fad', 'user']"/>&nbsp;{{_[abstract.setting_submission_id].author.title_presenter}}</span>
              <span class="my-auto" v-else><icon :icon="['fad', 'user']"/>&nbsp;{{_[abstract.setting_submission_id].author.title_author}}</span>
            </div>
          </div>
        </div>
        <!--        <div class="row mt-3">-->
        <!--          <div class="col">-->
        <!--            <speaker v-if="needPresenterData() || (author && author.role_id === 2)"-->
        <!--                     :submission_id="abstract.setting_submission_id" area="author"-->
        <!--                     textkey="info_top_presenter"></speaker>-->
        <!--            <speaker v-else :submission_id="abstract.setting_submission_id" area="author"-->
        <!--                     textkey="info_top_coauthor"></speaker>-->
        <!--          </div>-->
        <!--        </div>-->
        <div class="row mt-3" v-if="!editAuthor">
          <div class="col">
            <button class="btn btn-primary" v-on:click="cloneContact()">
              <icon :icon="['fad', 'copy']"/>&nbsp;{{_[abstract.setting_submission_id].author.button_copy}}
            </button>
          </div>
        </div>
        <entitegenerator v-if="author"
                         :entities="entities"
                         :values="author"
                         :system="{main: 'submission', action: 'create'}"
                         :models="{'gender':gender,'salutation':salutation, 'unprogramme_list': datahelper.unprogramme_list, 'countries':countryData()}"
                         :error="globalerror"
                         :language="language"
                         mode="formular"></entitegenerator>
        <Loader v-else></Loader>
      </div>
    </div>
    <div class="row mt-3" v-if="mode.confirm === true">
      <div class="col d-flex">
        <router-link :to="'/abstract/' + this.$route.params.id + '/confirm'" class="pull-left">
          <button type="button" class="btn btn-info">
            <icon :icon="['fas', 'angle-left']" size="lg"/>
            {{_[abstract.setting_submission_id].author.button_back_no_save}}
          </button>
        </router-link>
        <button v-if="!editAuthor && !processing.author" type="button" class="btn btn-success ml-auto"
                v-on:click="createAuthor()">
          <icon :icon="['fal', 'save']" size="lg"/>
          {{_[abstract.setting_submission_id].author.button_add_institute_with_save}}
        </button>
        <button v-if="(editAuthor && editorMode === 'formular') && !processing.author" type="button"
                class="btn btn-success ml-auto"
                v-on:click="putAuthor()">
          <icon :icon="['fal', 'save']" size="lg"/>
          {{_[abstract.setting_submission_id].author.button_back_with_save}}
        </button>
        <button class="btn btn-success ml-auto" type="button" disabled v-if="processing.author">
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          {{wording[0].buttons.processing}}
        </button>
      </div>
    </div>
    <div class="row mt-3" v-else>
      <div class="col d-flex">
        <router-link :to="'/abstract/' + this.$route.params.id + '/authors'" class="pull-left">
          <button type="button" class="btn btn-info">
            <icon :icon="['fas', 'angle-left']" size="lg"/>
            {{_[abstract.setting_submission_id].author.button_back_no_save}}
          </button>
        </router-link>
        <button v-if="!editAuthor && !processing.author" type="button" class="btn btn-success ml-auto"
                v-on:click="createAuthor()">
          <icon :icon="['fal', 'save']" size="lg"/>
          {{_[abstract.setting_submission_id].author.button_add_institute_with_save}}
        </button>
        <button v-if="(editAuthor && editorMode === 'formular') && !processing.author" type="button"
                class="btn btn-success ml-auto"
                v-on:click="putAuthor()">
          <icon :icon="['fal', 'save']" size="lg"/>
          {{_[abstract.setting_submission_id].author.button_back_with_save}}
        </button>
        <button class="btn btn-success ml-auto" type="button" disabled v-if="processing.author">
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          {{wording[0].buttons.processing}}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
  import {mapActions, mapState, mapGetters} from 'vuex'
  import entitegenerator from 'entite-generator';

  export default {
    name: "AuthorForm",
    components: {entitegenerator},
    data() {
      return {
        institute: {},
        editorMode: 'formular',
        editAuthor: false,
        error: null,
      };
    },
    computed: {
      ...mapState([
        'abstract',
        'author',
        'authors',
        'institutes',
        'wording',
        'countries',
        'settings',
        'salutation',
        'processing',
        'user',
        'authorvalidation',
        'datahelper',
        'gender',
        'mode',
        "language"
      ]),
      ...mapGetters([
        'getCurrentPageByType'
      ]),
      entities: function () {
        if (this.needPresenterData() || (this.author && this.author.role_id === 2) || this.abstract.setting_submission_id === 2 || this.abstract.setting_submission_id === 3) {
          return this.getCurrentPageByType(this.abstract.setting_submission_id, 2).entity.presenter.author
        }
        return this.getCurrentPageByType(this.abstract.setting_submission_id, 2).entity.coauthor.author
      },
      globalerror: function () {
        if (this.error) {
          return this.error;
        }
        if ((this.author.id && this.author.id > 0) && (this.authorvalidation.is_checked === true && this.authorvalidation.status === false)) {
          let validation = this.authorvalidation.errors.find(valid => valid.author_id === this.author.id);
          if (validation && validation.error) return validation.error;
        }
        return {}
      },
    },
    created() {
      if (this.$route.params.authorid) {
        this.editAuthor = true;
      } else {
        this.$store.commit('SET_AUTHOR', {"author": {}});
      }
    }
    ,
    methods: {
      ...
          mapActions([
            'VALIDATE_TARGET', 'CREATE_AUTHOR', 'PUT_AUTHOR'
          ]),
      createAuthor() {
        if (this.authors.find(author => author.firstname.toLowerCase() === this.author.firstname.toLowerCase() && author.lastname.toLowerCase() === this.author.lastname.toLowerCase())) {
          this.$noty.error(this.wording[this.abstract.setting_submission_id].notify.author_exist);
          this.processing.author = false;
          return false;
        }
        //SESSION SPECIAL
        if (this.abstract.setting_submission_id === 2 || this.abstract.setting_submission_id === 3) {
          let presentations = {};
          this.authors.forEach((element, index) => {
            let presentation = element.additional_content.presentation_title.toLowerCase();
            if (!this.containsKey(presentations, presentation)) {
              presentations[presentation] = 0;
            }
            presentations[presentation]++;
          });
          if (presentations[this.author.additional_content__presentation_title.toLowerCase()] >= 2) {
            this.$noty.error('Save was <strong>not</strong> successful, the presentation has reached the speaker limit.');
            this.processing.author = false;
            return false;
          }
          let maxPresentations = 5;
          switch (this.abstract.type_id) {
            case 7:
            case 4: {
              maxPresentations = 5;
              break;
            }
            case 5:
            case 6: {
              maxPresentations = 5;
              if (this.abstract.content__duration == '6 hours') {
                maxPresentations = 10;
              }
              break;
            }
          }
          if (Object.keys(presentations).length >= maxPresentations) {
            this.$noty.error('Save was <strong>not</strong> successful, the limit of presentations reached.');
            this.processing.author = false;
            return false;
          }
        }
        this.processing.author = true;
        let needpresenter = this.needPresenterData();
        let target = this.abstract.setting_submission_id + '/';
        target += needpresenter ? 'presenter/author' : 'coauthor/author';
        let data = {template: {}, target: target};
        data.template = this.author;
        data.template.abstract_id = this.$route.params.id;
        data.template.order = this.$store.state.authors.length + 1;
        let role_id = needpresenter ? 2 : 1;
        if (this.abstract.setting_submission_id === 2 || this.abstract.setting_submission_id === 3) {
          //SESSION hat nur Presenter/Speaker
          role_id = 2;
        }
        data.template.role_id = role_id;
        this.VALIDATE_TARGET(data).then((validationresult) => {
          this.editorMode = 'preview';
          this.CREATE_AUTHOR(data).then((responseAuthor) => {
            this.processing.author = false;
            this.$noty.success(this.wording[0].notify.save_success);
            this.error = {};
            this.$router.push(responseAuthor.data.id + '/institute/add');
          }).catch((error) => {
            this.$noty.error(this.wording[0].notify.save_not_success);
            this.processing.author = false;
          })
        }).catch((error) => {
          this.$noty.error(this.wording[0].notify.validation_error);
          this.processing.author = false;
          this.error = error.response.data;
        })
      }
      ,
      putAuthor() {
        this.processing.author = true;
        let target = this.abstract.setting_submission_id + '/';
        target += this.author.role_id === 2 ? 'presenter/author' : 'coauthor/author';
        this.VALIDATE_TARGET({
          template: this.author,
          target: target
        }).then((result) => {
          this.error = {};
          this.PUT_AUTHOR({
            id: this.author.id,
            abstract_id: this.author.abstract_id,
            template: this.author
          }).then((result) => {
            this.$noty.success(this.wording[0].notify.save_success);
            this.processing.author = false;
            this.error = {};
            if (this.mode.confirm === true) {
              this.$router.push('/abstract/' + this.$route.params.id + '/confirm');
            } else {
              this.$router.push('/abstract/' + this.$route.params.id + '/authors');
            }
          }).catch((error) => {
            this.$noty.error(this.wording[0].notify.save_not_success);
            this.processing.author = false;
            this.error = error.response.data;
          })
        }).catch((error) => {
          this.$noty.error(this.wording[0].notify.validation_error);
          this.processing.author = false;
          this.error = error.response.data;
        })
      },
      cloneContact() {
        this.copyContactfield('firstname', 'firstName');
        this.copyContactfield('lastname', 'lastName');
        if (this.needPresenterData() || this.abstract.setting_submission_id === 2 || this.abstract.setting_submission_id === 3) {
          this.copyContactfield('email', 'emailBusiness');
        }
      },
      copyContactfield(to, from) {
        if (this.user[from]) {
          this.$set(this.author, to, this.user[from])
        }
      }
    }
  }
</script>
